import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { partnerForgotPassword, partnerResetPassword } from "../../services/partnerCalls";
import { Shell, Card, Btn, Input, Note } from "./portalPublic";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await partnerForgotPassword({ email }); } catch (_) {}
    setSent(true);
    setBusy(false);
  };
  return (
    <Shell>
      <Card title="Reset your password">
        {sent ? (
          <>
            <Note>If an account exists for that email, we've sent a reset link. Check your inbox.</Note>
            <Link to="/partner-login"><Btn>Back to sign in</Btn></Link>
          </>
        ) : (
          <form onSubmit={submit}>
            <Input type="email" placeholder="Work email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <Btn type="submit" disabled={busy}>{busy ? "Sending…" : "Send reset link"}</Btn>
          </form>
        )}
      </Card>
    </Shell>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const t = params.get("t") || params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    // the same rule the partner API applies
    if (password.length < 10) return setError("Choose a password of at least 10 characters.");
    if (!/[A-Za-z]/.test(password) || !/[0-9]/.test(password)) return setError("Use both letters and numbers in your password.");
    if (password !== confirm) return setError("Passwords don't match.");
    setBusy(true);
    try {
      await partnerResetPassword({ token: t, password });
      setDone(true);
    } catch (err) {
      setError(err?.response?.data?.message || "This reset link is invalid or has expired.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <Shell>
      <Card title="Set a new password">
        {error && <Note tone="error">{error}</Note>}
        {done ? (
          <>
            <Note>Your password has been updated.</Note>
            <Link to="/partner-login"><Btn>Go to sign in →</Btn></Link>
          </>
        ) : (
          <form onSubmit={submit}>
            <Input type="password" placeholder="New password (min 10 chars, letters and numbers)" value={password} onChange={(e) => setPassword(e.target.value)} />
            <Input type="password" placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            <Btn type="submit" disabled={busy}>{busy ? "Saving…" : "Update password"}</Btn>
          </form>
        )}
      </Card>
    </Shell>
  );
}
